import { Button } from '@/components/ui/button';
import { CONTEXT_LABEL, PUBLIC_CONTEXTS } from '@/lib/auth/access';
import type { Context } from '@/lib/store/ui';
import { useUiStore } from '@/lib/store/ui';
import { Lock } from 'lucide-react';

/** "Drones, Operational Intents and Surveillance" — follows PUBLIC_CONTEXTS. */
const PUBLIC_LABELS = new Intl.ListFormat('en', { type: 'conjunction' }).format(
  PUBLIC_CONTEXTS.map((c) => CONTEXT_LABEL[c]),
);

/**
 * Shown in place of a context body when a public (unauthenticated) visitor
 * opens a gated context. Sprint 26 — 86e22kuvm (public view restrictions).
 */
export function ContextLoginGate({ ctx }: { ctx: Context }) {
  const setLoginOpen = useUiStore((s) => s.setLoginOpen);
  const label = CONTEXT_LABEL[ctx];

  return (
    <div className="absolute inset-0 flex items-center justify-center p-6 bg-(--color-bg)">
      <div className="max-w-sm w-full text-center rounded-xl border border-(--color-border) bg-(--color-surface) p-8 shadow-sm">
        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-(--color-green-bg) text-(--color-green)">
          <Lock size={20} />
        </div>
        <h2 className="text-[1.077em] font-bold text-(--color-text)">Sign in to view {label}</h2>
        <p className="mt-2 text-[0.846em] text-(--color-text3) leading-snug">
          The {label} view is available to authenticated users. {PUBLIC_LABELS} stay open to
          everyone — sign in to unlock the rest.
        </p>
        <Button className="mt-5 w-full" onClick={() => setLoginOpen(true)}>
          <Lock size={13} /> Log in to continue
        </Button>
      </div>
    </div>
  );
}
